import * as React from "react";
import styles from "../../styles/AsignacionProgramasStyles/PantallaDeAsignacionProgramaMateria.module.css";

function SemesterTable({ semesterNumber, subjects, periodLabel = 'Tetramestre', onDropSubject, onRemoveSubject }) {
  const handleDragOver = (e) => {
    e.preventDefault(); // Permite el drop
  };

  const handleDrop = (e) => {
    e.preventDefault();
    try {
      const data = e.dataTransfer.getData('application/json');
      if (!data) return;
      const subject = JSON.parse(data);
      if (onDropSubject) onDropSubject(semesterNumber, subject);
    } catch {}
  };

  return (
    <div
      className={styles.semesterTable}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <header className={styles.semesterHeader}>
        <h3 className={styles.semesterTitle}>{periodLabel} {semesterNumber}</h3>
      </header>
      <div className={styles.subjectsContent}>
        {subjects.map((subject, index) => (
          <div
            key={(subject.id || subject.name) + index}
            className={styles.subjectItem}
            draggable
            onDragStart={(e) => {
              try {
                e.dataTransfer.setData('application/json', JSON.stringify({ ...subject, sourcePeriodNumber: semesterNumber }));
              } catch {}
            }}
            onDoubleClick={() => {
              if (onRemoveSubject) onRemoveSubject(semesterNumber, subject);
            }}
          >
            <p className={styles.subjectName}>{subject.name}</p>
            <p className={styles.subjectCredits}>{subject.credits !== null && subject.credits !== undefined ? `${subject.credits} créditos` : 'Sin créditos'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SemesterTable;
